import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

import "../../../styles/components/legal/Legal.scss";

class Privacy extends Component {
  render() {
    return (
      <div id="privacy">
        <div className="pp-title">
          <Translate value="legalPP_privacy" />
        </div>
      </div>
    );
  }
}

export default Privacy;
